export default "__VITE_ASSET__028c18a0__"